import {
  UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
  useInfiniteQuery,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ResponderVehicles, ResponderCompany } from "@/services";
import { toast } from "sonner";
import { queries } from "../services/queries";

export const useGetResponderCompanyVehicles = (
  pageSize: number,
  companyId: number,
  search?: string
) => {
  return useInfiniteQuery({
    queryKey: [
      "responderVehicles",
      "responderCompany",
      { pageSize, companyId, search },
    ],
    queryFn: ({ pageParam = 1 }) =>
      ResponderVehicles.getResponderCompanyVehicles(
        pageParam,
        pageSize,
        companyId,
        search
      ),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      return lastPage.hasNextPage ? nextPage : undefined; // Assuming lastPage includes hasNextPage indicator
    },
    initialPageParam: 1,
  });
};

export const useCreateResponderVehicle = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ResponderVehicles.createVehicle,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["responderVehicles"] });
      return data;
    },
    onError: (err: Error) => {
      if (err.message) {
        toast.error(err.message);
      } else {
        toast.error("An error occurred");
      }
    },
    meta: {
      useError: true,
    },
  });
};

export const useUpdateResponderVehicle = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ResponderVehicles.updateVehicle,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["responderVehicles"] });
      return data;
    },
    onError: (err: Error) => {
      if (err.message) {
        toast.error(err.message);
      } else {
        toast.error("An error occurred");
      }
    },
    meta: {
      useError: true,
    },
  });
};
